import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      onClick={toggleTheme}
      role="switch"
      aria-checked={isLight}
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      className="w-full flex items-center justify-between gap-3 px-2 py-1.5 rounded-md hover:bg-white/10 transition-colors duration-200"
    >
      <span className="flex items-center gap-2 text-sm">
        {isLight ? <Sun className="w-4 h-4 text-amber-400" /> : <Moon className="w-4 h-4 text-violet-300" />}
        <span>{isLight ? "Light mode" : "Dark mode"}</span>
      </span>
      <span
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-300 ${
          isLight ? "bg-amber-400" : "bg-violet-600"
        }`}
      >
        <span
          className={`absolute flex h-5 w-5 items-center justify-center rounded-full bg-white shadow-md transition-transform duration-300 ${
            isLight ? "translate-x-[22px]" : "translate-x-[2px]"
          }`}
        >
          {isLight ? <Sun className="w-3 h-3 text-amber-500" /> : <Moon className="w-3 h-3 text-violet-600" />}
        </span>
      </span>
    </button>
  );
}
